import React from 'react'
import ReactQuill from 'react-quill'

import { SortableElement } from 'react-sortable-hoc'

import styled from 'styled-components'
import Constants from '../../post/Tab.Content/constants'

import Delay from '../../../components/DelayedInput'
import Node from '../../post/Tab.Content/node/parent'

import Style from './Field.Style'
import { Form } from 'antd'

const Container = styled.div`
    .quill
    {
        background-color: white;

        .ql-toolbar.ql-snow
        {
            border: none;
            border-bottom: 1px solid #e8e8e8;
        }

        .ql-container.ql-snow
        {
            min-height: 120px;
            border: none;

            .ql-tooltip
            {
                z-index: 999999;
            }

            strong
            {
                font-weight: bold;
            }
        }

        ${props => !!props.disabled && `
            pointer-events: none;
            opacity: 0.6;
        `}
    }
`

const Box = styled.div`
    background-color: #f9f9f9;
    border-top: 1px solid #d9d9d9;

    padding: 8px;

    .ant-form-item
    {
        margin-bottom: 0;
        padding-bottom: 0;
    }

    ${props => props.padding === 'small' && `
        padding: 4px;
    `}

    ${props => props.direction === 'horizontal' && `
        display: flex;

        flex-direction: row;
        flex-wrap: wrap;
    `}
`

function Comp (
    {
        action,
        
        sortIndex,
        length,

        id,
        type,
        value = '',
        options = {},
        style = {},

        onChange,
    }
)
{
    function handleChange (changedValue)
    {
        onChange('edit', sortIndex, { id, type, options, style, value: changedValue })
    }

    function handleStyleChange (style)
    {
        if (typeof onChange === 'function')
        {
            onChange('edit', sortIndex, { id, type, options, style, value })
        }
    }

    const onNodeChange = onChange

    return (
        <Delay
            value={value}
            onChange={handleChange}
        >
            {
                ({ value, onChange }) => (
                    <Node
                        title="ข้อความ"
                        action={action}

                        index={sortIndex}
                        length={length}

                        id={id}
                        type={type}
                        value={value}
                        options={options}
                        
                        onChange={onNodeChange}
                    >
                        <Container disabled={!!action} >
                            <ReactQuill 
                                id={id}
                                value={value}
                                onChange={onChange}
                                bounds={`#content-editor`}
                                placeholder="แก้ไขข้อความที่นี่"
                                preserveWhitespace={false}
                                modules={
                                    {
                                        toolbar:
                                        [
                                            [{ 'size': ['small', false, 'large' ] }],
                                            [{ 'header': 1 }, { 'header': 2 }],
                                            ['bold', 'italic', 'underline', 'strike'],
                                            ['link'],
                                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                            [{ 'script': 'sub'}, { 'script': 'super' }],
                                            [{ 'color': Constants.colors }, ],
                                            [{ 'align': [] }],
                                        ]
                                    }
                                }
                            />

                            <Box>
                                <Form layout="vertical" >
                                    <Style 
                                        layout={{ colon: false }}
                                        value={style}
                                        onChange={handleStyleChange}
                                    />
                                </Form>
                            </Box>
                        </Container>
                    </Node>
                )
            }
        </Delay>
    )
}

export default SortableElement(Comp)